module.exports = __webpack_public_path__ + "img/logo.57f68a2b.png";